"use client";

import { useTranslations } from "next-intl";

/** Öffnet die Cookie-Einstellungen erneut (Widerruf/Änderung der Einwilligung).
 *  Reviewer 18.09.2026: bisher gab es nach der ersten Entscheidung keinen Weg
 *  zurück ins Consent-Modal. Wird im Footer von www und im Buchungs-Chrome
 *  gerendert; die Bibliothek wird erst beim Klick geladen. */
export function CookieSettingsLink({ className }: { className?: string }) {
  const t = useTranslations("Privacy");
  const label = t.has("cookieSettings" as never) ? t("cookieSettings" as never) : "Cookie-Einstellungen";
  return (
    <button
      type="button"
      data-testid="cookie-settings"
      onClick={() => {
        void import("vanilla-cookieconsent").then((CC) => CC.showPreferences());
      }}
      className={className ?? "hover:text-brand-600"}
    >
      {label}
    </button>
  );
}
